import { log } from './logger';

const isLocal = process.env.NODE_ENV === 'development';
const isServer = typeof window === 'undefined';

export const getBuildVersion = (): string => {
    if (isServer) {
        const buildVersion = process.env.BUILD_VERSION || '';
        if (!buildVersion) log.debug('Could not read local version file from server');
        // On the server, we fetch the version from the local file
        return buildVersion;
    } else {
        // On the client we get the version from the html meta tag 'version'.
        // Is being injected in _document.tsx when the router returns the html render
        const versionMetaTag = window.document.head.children.namedItem('version');
        if (!versionMetaTag) {
            if (!isLocal) {
                log.debug('Could not find "version" meta tag in the client html');
            }
        }
        return versionMetaTag?.getAttribute('content') || '';
    }
};

export const getAssetsPrefix = (): string => {
    return process.env.ASSET_PREFIX || '';
};
